import React from 'react';
import { Button } from '@material-ui/core';
import Img from 'retired/Img';
import ExternalLinkIcon from 'assets/icons/external-link.svg';

export interface ViewInAppButtonProps {
  href: string;
  text?: string;
  style?: React.CSSProperties;
  iconSize?: number;
  title?: string;
  disabled?: boolean;
}

const ViewInAppButton: React.FC<ViewInAppButtonProps> = ({
  href,
  text = 'View in app',
  style = {},
  iconSize = 16,
  title,
  disabled = false,
}) => {
  const iconElement = (
    <Img
      src={ExternalLinkIcon}
      alt="External Link Icon"
      style={{
        width: iconSize,
        height: iconSize,
        marginLeft: 5,
        ...(disabled && { filter: 'grayscale(100%)' }),
      }}
    />
  );

  const commonProps = {
    target: '_blank',
    rel: 'noreferrer',
    ...(title && { title }),
  };

  return (
    <a
      href={href}
      style={{
        ...(disabled && {
          pointerEvents: 'none',
          color: '#ccc',
        }),
        ...style,
      }}
      {...commonProps}
    >
      {text} {iconElement}
    </a>
  );
};

export default ViewInAppButton;
